module.exports = __webpack_public_path__ + "img/i-home-gold.04f10a18.svg";